export default "__VITE_ASSET__BDKcgNFM__"